import {Typography, Grid} from "@mui/material";
import React, {FC, isValidElement} from "react";

export interface GridItemProps {
    size?: number;
    title?: string | React.ReactNode;
    content?: string | React.ReactNode;
    alignContent?: "center" | "end" | "flex-end" | 'space-around' | "start";
    minHeight?: number | string;
}

export const GridItem: FC<GridItemProps> = ({size = 6, title, content, minHeight = 0, alignContent = 'start'}) => {
    return <Grid size={size}>
        {isValidElement(title) ? title : <Typography variant={'caption'} color={'#525967'} component={'div'} fontSize={'14px'}>{title}</Typography>}
        <Typography variant={"body1"} alignContent={alignContent} bgcolor={'#f2f2f2'} px={'8px'} py={'5px'}
                    mt={'2px'} borderRadius={'2px'}
                    minHeight={minHeight} fontSize={'14px'}
                    color={'#141e31'} component={'div'}>{content || "-"}</Typography>
    </Grid>
}


// styled(TextField)(({theme}) => ({
//     "& .MuiOutlinedInput-root": {
//         backgroundColor: '#f5f5f470',
//         border: 'none',
//         [`& .${outlinedInputClasses.notchedOutline}`]: {
//             border: `1px solid ${(theme.vars || theme).palette.divider}`,
//         },
//         "&:hover": {
//             borderColor: 'transparent',
//         },
//         [`&.${outlinedInputClasses.focused}`]: {
//             outline: 'none',
//             borderColor: 'transparent',
//         },
//     },
//
// }))